<template>
  <div class="louFeng-box">
    <!--操作栏-->
    <div class="action-bar">
      置顶等级 ：
      <el-select v-model="params.topLevel" size="small" placeholder="置顶状态" clearable @change="getLouFengList">
        <el-option v-for="item in topLevels" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      是否激活 ：
      <el-select v-model="params.isActive" size="small" placeholder="是否激活" clearable @change="getLouFengList">
        <el-option v-for="item in reviewStatusFunction" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      是否验证 ：
      <el-select v-model="params.isVerify" size="small" placeholder="是否验证" clearable @change="getLouFengList">
        <el-option v-for="item in Verifys" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      是否推荐 ：
      <el-select v-model="params.isTopSort" size="small" placeholder="是否推荐" clearable @change="getLouFengList">
        <el-option v-for="item in IsTopSortStatus" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      <el-input placeholder="经纪人ID" v-model="params.publisher" clearable size="small" @change="getLouFengList()" class="param-input"></el-input>
      <el-input placeholder="城市" v-model="params.city" clearable size="small" @change="getLouFengList()" class="param-input"></el-input>
      <el-input placeholder="区，县" v-model="params.district" clearable size="small" @change="getLouFengList()" class="param-input"></el-input>
      <el-input placeholder="标题" v-model="params.title" clearable size="small" @change="getLouFengList()" class="param-input"></el-input>
      <el-input placeholder="月份" v-model="params.businessDate" clearable size="small" @change="getLouFengList()" class="param-input"></el-input>
      <el-input placeholder="ID" v-model="params.id" clearable size="small" @change="getLouFengList()" class="param-input"></el-input>
      <el-input placeholder="联系方式" v-model="params.contact" clearable size="small" @change="getLouFengList()" class="param-input"></el-input>
      <el-button type="primary" size="small" @click="getLouFengList('status')" style="margin-right: 10px">搜索</el-button>
      <el-button type="primary" size="small" @click="Action('add')" class="add-input">+新增楼凤信息</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable" height="550" @sort-change="handleSortChange">
      <el-table-column prop="id" label="ID" align="center" fixed min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="publisher" label="经纪人ID" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.publisher || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cover" label="封面" align="center" width="200">
        <template slot-scope="scope">
          <span v-if="!scope.row.cover || !scope.row.cover.length">未知</span>
          <div v-else class="picturePreview" @click="previewPicture(scope.row.cover, scope.row.id)">
            <gallery :list="scope.row.cover" ></gallery>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="city" label="城市" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.city || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="district" label="区,县" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.district }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="age" label="年龄" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.age || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="contact" label="联系方式" align="center" min-width="260">
        <template slot-scope="scope">
          <span>{{ scope.row.contact }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="contactPrice" label="联系方式价格（金币）" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.contactPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="数量" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ (scope.row.quantity || '未知') | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="serviceItems" label="服务项目" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.serviceItems }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格（元）" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.price || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="businessHours" label="营业时间" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.businessHours }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="loufengType" label="楼凤类型" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{
            scope.row.loufengType === 'pluralism' ? '楼凤兼职' : '未知'
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="impression" label="狼友印象" align="center" min-width="200" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.impression || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="envStar" label="环境评分" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.envStar || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="prettyStar" label="颜值评分" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.prettyStar }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="serviceStar" label="服务评分" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.serviceStar }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="overallRatings" label="综合评分" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.overallRatings }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="businessDate" label="营业月份" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.businessDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="isActive" label="是否激活" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.isActive == true ? '激活' : '未激活' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="isVerify" label="是否验证" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.isVerify == true ? '验证' : '未验证' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="countPurchases" label="购买数" align="center" min-width="120" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ scope.row.countPurchases }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="countBrowse" label="浏览数" align="center" min-width="120" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ scope.row.countBrowse }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="countCollect" label="收藏数" align="center" min-width="120" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ scope.row.countCollect }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="topLevel" label="置顶类型" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.topLevel | topLevels }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="topSort" label="排序名次" align="center" min-width="120">
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="修改时间" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="topStartTime" label="开始时间" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.topStartTime | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="280">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="Action('edit', scope.row)"></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="remove(scope.row.id)"></el-button>
          <el-button type="success" size="mini" @click="upmost(scope.row)">置顶</el-button>
          <el-button type="danger" size="mini" @click="cancelTop(scope.row.id)" :disabled="!scope.row.topLevel">取消置顶</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!--新增、编辑弹框-->
    <operating-page ref="operatingPage" @handlerChannelList="getLouFengList"></operating-page>
    <!-- 背景图集预览窗口 -->
    <preview-picture ref="previewPicture" @handlerChannelList="getLouFengList"></preview-picture>
    <!-- 置顶窗口 -->
    <upmost ref="upmost" @handlerChannelList="getLouFengList"></upmost>
  </div>
</template>

<script>
import API from "@/api";
import OperatingPage from "./components/operatingPage";
import baseConfig from "@/utils/serverUrlConfig";
import PreviewPicture from "./components/previewPicture";
import { sortEscape } from "@/utils/global";
import Upmost from "./components/upmost";
export default {
  data() {
    return {
      imgUrl: baseConfig.imgUrl,
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      // 系统管理列表请求参数
      params: {
        pageNumber: 1,
        pageSize: 10,
        publisher: undefined, // 经纪人ID
        topLevel: "",
        key: "",
        value: "",
      },
      topLevels: [
        {
          value: 20,
          label: "全局置顶",
        },
        {
          value: 10,
          label: "城市置顶",
        },
        {
          value: 9,
          label: "城市次级置顶",
        },
      ],
      reviewStatusFunction: [
        { label: "激活", value: true },
        { label: "未激活", value: false },
      ],
      IsTopSortStatus: [
        { label: "推荐", value: true },
        { label: "未推荐", value: false },
      ],
      Verifys: [
        { label: "验证", value: true },
        { label: "未验证", value: false },
      ],
    };
  },
  components: {
    OperatingPage,
    PreviewPicture,
    Upmost,
  },
  created() {
    this.getLouFengList();
  },
  methods: {
    // 请求楼凤信息列表
    getLouFengList(type) {
      this.loading = true;
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getLouFengList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 删除
    remove(id) {
      this.$confirm("您确定要删除当前信息吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          API.deleteLoufeng({ id: id }).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getLouFengList();
            } else {
              this.$message.error("删除失败");
            }
          });
        })
        .catch(() => {});
    },
    // 数据排序
    handleSortChange(column) {
      this.params.value = sortEscape(column.order);
      this.params.key = column.prop;
      this.getLouFengList();
    },
    // 新增、编辑操作
    Action(type, data) {
      this.$refs.operatingPage.open(type, data);
    },
    //  图集预览
    previewPicture(pictureArr, id) {
      const Arr = JSON.parse(JSON.stringify(pictureArr));
      this.$refs.previewPicture.open(Arr, id);
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size;
      this.getLouFengList();
    },
    // 分页页码改变回掉
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getLouFengList();
    },
    // 置顶操作
    upmost(data) {
      this.$refs.upmost.open(data);
    },
    // 取消置顶
    cancelTop(id) {
      API.cancelToplf({ id: id }).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "取消置顶操作成功！",
            type: "success",
          });
          this.getLouFengList();
        } else {
          this.$message.error("取消置顶操作失败！");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.payMethod {
  .add-input {
    margin-left: 0 !important;
  }
}
</style>
